import { useNavigate, Link } from 'react-router-dom';
import { Mic, Scissors, Download, TrendingUp, Shield, Zap } from 'lucide-react';

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      {/* Header */}
      <header className="border-b border-slate-200 bg-white/80 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              CLIPD
            </h1>
            <p className="text-xs text-slate-500">Maudhui Pendwa kwa Wananchi</p>
          </div>
          <div className="flex gap-3">
            <button
              onClick={() => navigate('/login')}
              className="px-4 py-2 text-slate-700 hover:text-blue-600 font-medium transition-colors"
            >
              Ingia
            </button>
            <button
              onClick={() => navigate('/signup')}
              className="px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all font-medium"
            >
              Jisajili
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center">
          <h2 className="text-5xl font-bold text-slate-900 mb-6">
            Badilisha Hotuba Ndefu Kuwa
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"> Clips Za Viral</span>
          </h2>
          <p className="text-xl text-slate-600 mb-8 max-w-3xl mx-auto">
            AI inakusaidia kupata moments bora kutoka kwenye hotuba za viongozi na kuzifanya kuwa 
            short clips za 15-30 seconds kwa TikTok, Instagram Reels, na YouTube Shorts.
          </p>
          <div className="flex gap-4 justify-center">
            <button
              onClick={() => navigate('/signup')}
              className="px-8 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all font-semibold text-lg shadow-lg"
            >
              Anza Sasa - TSh 5,000/siku
            </button>
          </div>
          <p className="text-sm text-slate-500 mt-4">
            Hakuna card inayohitajika. Lipia kwa siku moja tu.
          </p>
        </div>
      </section>

      {/* Features */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 bg-white">
        <h3 className="text-3xl font-bold text-center text-slate-900 mb-12">
          Features Zetu
        </h3>
        <div className="grid md:grid-cols-3 gap-8">
          <div className="p-6 bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl">
            <Mic className="w-12 h-12 text-blue-600 mb-4" />
            <h4 className="text-xl font-semibold text-slate-900 mb-2">
              Transcription ya Kiswahili
            </h4>
            <p className="text-slate-600">
              Whisper.cpp inafasiri audio kuwa text kwa usahihi wa hali ya juu.
            </p>
          </div>
          <div className="p-6 bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl">
            <Scissors className="w-12 h-12 text-purple-600 mb-4" />
            <h4 className="text-xl font-semibold text-slate-900 mb-2">
              AI Auto-Clipping
            </h4>
            <p className="text-slate-600">
              AI inapata moments bora na kuzipendekeza kwa viral content.
            </p>
          </div>
          <div className="p-6 bg-gradient-to-br from-green-50 to-green-100 rounded-xl">
            <Download className="w-12 h-12 text-green-600 mb-4" />
            <h4 className="text-xl font-semibold text-slate-900 mb-2">
              Export 9:16 Vertical
            </h4>
            <p className="text-slate-600">
              Export moja kwa moja kwa TikTok, Reels, na Shorts.
            </p>
          </div>
          <div className="p-6 bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl">
            <TrendingUp className="w-12 h-12 text-orange-600 mb-4" />
            <h4 className="text-xl font-semibold text-slate-900 mb-2">
              Virality Scoring
            </h4>
            <p className="text-slate-600">
              Kila clip inapata score kulingana na uwezekano wa ku-viral.
            </p>
          </div>
          <div className="p-6 bg-gradient-to-br from-red-50 to-red-100 rounded-xl">
            <Shield className="w-12 h-12 text-red-600 mb-4" />
            <h4 className="text-xl font-semibold text-slate-900 mb-2">
              100% Local Processing
            </h4>
            <p className="text-slate-600">
              Video yote inafanyika local. Hakuna upload kwenda server.
            </p>
          </div>
          <div className="p-6 bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-xl">
            <Zap className="w-12 h-12 text-indigo-600 mb-4" />
            <h4 className="text-xl font-semibold text-slate-900 mb-2">
              Fast & Efficient
            </h4>
            <p className="text-slate-600">
              FFmpeg inafanya processing haraka na efficient.
            </p>
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <h3 className="text-3xl font-bold text-center text-slate-900 mb-12">
          Bei Rahisi
        </h3>
        <div className="max-w-md mx-auto">
          <div className="bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl p-8 text-white shadow-2xl">
            <h4 className="text-2xl font-bold mb-2">Daily Access</h4>
            <div className="text-5xl font-bold mb-4">
              TSh 5,000
              <span className="text-2xl font-normal opacity-80">/siku</span>
            </div>
            <ul className="space-y-3 mb-8">
              <li className="flex items-center gap-2">
                <span>✓</span> Features zote zimefunguliwa
              </li>
              <li className="flex items-center gap-2">
                <span>✓</span> Device moja (hakuna sharing)
              </li>
              <li className="flex items-center gap-2">
                <span>✓</span> Unlimited clips
              </li>
              <li className="flex items-center gap-2">
                <span>✓</span> AI transcription
              </li>
              <li className="flex items-center gap-2">
                <span>✓</span> 24hrs support
              </li>
            </ul>
            <button
              onClick={() => navigate('/signup')}
              className="w-full bg-white text-blue-600 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors"
            >
              Jisajili Sasa
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-slate-200 bg-white py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-600">&copy; 2026 CLIPD. Maudhui Pendwa kwa Wananchi.</p>
            <div className="flex gap-6">
              <Link to="/terms" className="text-sm text-slate-600 hover:text-blue-600">
                Masharti na Vigezo
              </Link>
              <Link to="/privacy" className="text-sm text-slate-600 hover:text-blue-600">
                Sera ya Faragha
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
